import React, { useEffect, useState, Children } from "react";
import { Button } from "react-bootstrap";
import {isValidName } from "../common/utilities/Validations";
import { CLIENT, CREATE_CLIENT_POST, getApiPath, LIST, UPDATE, VIEW, DYNAMIC_TABLE, GENERIC_DATA_CREATE_DEFAULT_TABLE } from "../../api/ApiConst";

import CloseButton from "react-bootstrap/CloseButton";

import MultiSelect from "../common/utilities/MultiSelect";
import { ACCESS_TOKEN_OPTIONS, AUTHORIZATION_GRANT_TYPES_OPTIONS, CLIENT_AUTHENTICATION_METHODS, TOKEN_SIGNATURE_ALGORITHM_OPTIONS } from "../../utils/constants/OptionConstants";
import apiCaller from "../../api/ApiCaller";
import { Tabs, Tab } from 'react-bootstrap';  
import { UserClientAccess } from "../../models/UserClientAccess";
import DocumentList from "../genericcrud/DocumentList";
import PromptEditor from "../genericcrud/PromptEditor";
import { toast } from "react-toastify";
import ClientConfig from "./ClientConfig";

const defaultObj = {
    id: "",
    clientName: "",
    clientLogoUri: "",
    thirdPartyId: "",
    ipAddress: "",
    clientId: "",
    clientSecret: "",
    postLogoutRedirectUris: [],
    redirectUris: [],
    primaryDbDetail: {
        host: "",
        port: 27017,
        dbName: "",
        authDbName: "admin",
        authUsername: "",
        authPassword: "",
    },
    secondaryDb: false,
    secondaryDbDetail: {
        host: "",
        port: 27017,
        dbName: "",
        authDbName: "admin",
        authUsername: "",
        authPassword: "",
    },
    backUpDb: false,
    backUpDbDetail: {
        host: "",
        port: 27017,
        dbName: "",
        authDbName: "admin",
        authUsername: "",
        authPassword: "",
    },
    authorizationCodeTimeToLive: 300,
    accessTokenTimeToLive: 300,
    accessTokenFormat: { label: "Self-Contained", value: "self-contained" },
    deviceCodeTimeToLive: 300,
    reuseRefreshTokens: true,
    refreshTokenTimeToLive: 3600,
    idTokenSignatureAlgorithm: {
        label: "RS256",
        value: "RS256"
    },
    requireProofKey: true,
    requireAuthorizationConsent: true,
    cscopy: "",
    scopes: [],
    clientAuthenticationMethods: [],
    authorizationGrantTypes: []
};


const ClientAddUpdate = (props) => {
    
    const [requestObj, setRequestObj] = useState({ ...defaultObj });
    const [activeTab, setActiveTab] = useState("general");
    const [loading, setLoading] = useState(false);
    

    const url = new URL(window.location.href);
    
    const clientId = url.pathname.split('/')[2]; // Example for extracting part of the path
    
    const getClient = (clientId) => {
        let getClient = getApiPath(CLIENT, VIEW, clientId);
        if (clientId !== 'add-client') {
            apiCaller.callGetApi(getClient, {}, (response) => {
                setRequestObj(response);
            }, (error) => {
                //    console.log(error);
            });
        }

    }
    const addDefaultTable = (clientId) => {
        const addDefaultTablePath = getApiPath(GENERIC_DATA_CREATE_DEFAULT_TABLE);
        apiCaller.callPostApi(addDefaultTablePath, {}, {}, (response) => {
            if(response===true){
                console.log("Default table created successfully",response);
            }else{
                toast.error(response?.message ||"Default table creation failed!");
            }
        },null,clientId);
    }

    useEffect(() => {
        if (clientId) {
            getClient(clientId);
            UserClientAccess.attributes.at(1).defaultValue = clientId;
            UserClientAccess.tableDataUrl = LIST+"/"+clientId
        }
    }, [clientId]);


    //Text Change Event for Input, text, Select
    const handleTextChange = (e, type, detailsObject) => {
        if (type === "checkbox") {
            if (!e.target.checked) {
                setRequestObj((prev) => ({
                    ...prev,
                    [e.target.id]: e.target.checked,
                    [detailsObject]: {
                        host: "",
                        port: NaN,
                        dbName: "",
                        authDbName: "",
                        authUsername: "",
                        authPassword: "",
                    },
                }));
            } else {
                setRequestObj((prev) => ({
                    ...prev,
                    [e.target.id]: e.target.checked,
                }));
            }
        } else if (type === "text") {
            if (e.target.id === "clientName") {
                let flag = isValidName(e.target.value);
                if (!flag) {
                    return;
                }
                setRequestObj((prev) => ({
                    ...prev,
                    [e.target.id]: e.target.value,
                }));
            }
            if (detailsObject !== "") {
                if (e.target.id === "authDbName" || e.target.id === "dbName" || e.target.id === "authUsername") {
                    let flag = isValidName(e.target.value);
                    if (!flag) {
                        return;
                    }
                    setRequestObj((prev) => ({
                        ...prev,
                        [detailsObject]: {
                            ...prev[detailsObject],
                            [e.target.id]: e.target.value,
                        },
                    }));
                } else {
                    setRequestObj((prev) => ({
                        ...prev,
                        [detailsObject]: {
                            ...prev[detailsObject],
                            [e.target.id]: e.target.value,
                        },
                    }));
                }
            }
            setRequestObj((prev) => ({ ...prev, [e.target.id]: e.target.value }));
        } else {

        }
    };

    useEffect(() => {
        if (props.object != null) {
            const redirectUrisProp = props.object?.redirectUris;
            setRequestObj({
                ...props.object,
                redirectUris: Array.isArray(redirectUrisProp) ? redirectUrisProp : (typeof redirectUrisProp === "string" ? redirectUrisProp.split(",") : []),
            });
        }
    }, [props.object]);

    const handleChecked = (e, key) => {
        const { checked } = e.target;
        setRequestObj((prev) => ({
            ...prev,
            [key]: checked
        }))
    }

    const handleNumbers = (e, key) => {
        const { value, name } = e.target;
        setRequestObj((prev) => ({
            ...prev,
            [name]: value
        }))
    }
    
    const handleMultiSelectChange = (field, values) => {
        setRequestObj((prev) => ({
            ...prev,
            [field]: values // Update with the selected string values
        }));
    };

    const handleMultiTabs = (e) => {
        const { value } = e.target;
        if (e.key === "Enter" || e.key === "Tab") {
            setRequestObj((prev) => ({
                ...prev,
                scopes: [...prev.scopes, value]
            }))
            const scopesInput = document.getElementById("scopesInput");
            scopesInput.value = "";
        }
    }

    const updateClient = () => {
        setLoading(true); // Start loading
        const updateClientPath = getApiPath(CLIENT, UPDATE, clientId); // Define your update API path
        
          
        requestObj.postLogoutRedirectUris = Array.isArray(requestObj.postLogoutRedirectUris)
        ? requestObj.postLogoutRedirectUris
        : [requestObj.postLogoutRedirectUris];
        apiCaller.callPutApi(
            updateClientPath,
            requestObj,{},
            (response) => {
                setLoading(false);
                toast.success("General information updated successfully!");
            },
            (error) => {
                setLoading(false);
                console.error("API Error:", error);
        
                if (error.response) {
                    console.error("Response Status:", error.response.status);
                    console.error("Response Data:", error.response.data);
        
                    toast.error(`Error: ${error.response.data.message || "Unknown error occurred"}`);
                } else if (error.request) {
                    console.error("Request Error:", error.request);
                    toast.error("No response from the server. Please try again.");
                } else {
                    console.error("Error Message:", error.message);
                    toast.error("An unexpected error occurred. Please try again.");
                }
            }
        );
        
        
    };

    const createClient = () => {
        setLoading(true); // Start loading
        delete requestObj.id;
        requestObj.postLogoutRedirectUris = Array.isArray(requestObj.postLogoutRedirectUris)
        ? requestObj.postLogoutRedirectUris
        : [requestObj.postLogoutRedirectUris];
        apiCaller.callPostApi(
            CREATE_CLIENT_POST,
            requestObj,{},
            (response) => {
                addDefaultTable(response?.id);
                setLoading(false);
                toast.success("Client Added successfully!");
                setRequestObj(defaultObj);
            },
            (error) => {
                setLoading(false);
                toast.error("Error updating general information. Please try again.");
                console.error(error);
                if(error?.id){
                    addDefaultTable(error?.id);
                }
            }
        );
    };

    return (

        <>
            <Tabs
                id="client-add-update-tabs"
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="mb-3"
            >
                <Tab eventKey="general" title="General Info">
                    <div>
                        <div className="row justify-content-end my-3">
                            <div className="col-12">
                            <div className="shadow p-3 mb-3 bg-body rounded database-div mt-1">
                                <div className="form-group row mb-2 row">
                                    <div className="form-group-item">
                                        <label>Client Name *</label>
                                        <input
                                            type="text"
                                            className="form-control input-default w-100"
                                            id="clientName"
                                            placeholder="Name"
                                            onChange={(e) => handleTextChange(e, e.target.type, "")}
                                            value={requestObj?.clientName}
                                        />
                                    </div>
                                    <div className="form-group-item">
                                        <label>Third Party Id *</label>
                                        <input
                                            type="text"
                                            className="form-control input-default w-100"
                                            id="thirdPartyId"
                                            placeholder="Third party Id"
                                            onChange={(e) => handleTextChange(e, e.target.type, "")}
                                            value={requestObj.thirdPartyId}
                                        />
                                    </div>
                                    <div className="form-group-item">
                                        <label>IP Address *</label>
                                        <input
                                            type="text"
                                            className="form-control input-default w-100"
                                            id="ipAddress"
                                            placeholder="IP Address"
                                            onChange={(e) => handleTextChange(e, e.target.type, "")}
                                            value={requestObj.ipAddress}
                                        />
                                    </div>
                                    <div className="form-group-item">
                                        <label>Client Logo Uri *</label>
                                        <input
                                            type="text"
                                            className="form-control input-default w-100"
                                            id="clientLogoUri"
                                            placeholder="Client Logo Uri"
                                            onChange={(e) => handleTextChange(e, e.target.type, "")}
                                            value={requestObj.clientLogoUri}
                                        />
                                    </div>
                                    <div className="form-group-item">
                                        <label>Client Id *</label>
                                        <input
                                            type="text"
                                            className="form-control input-default w-100"
                                            id="clientId"
                                            placeholder="Client Id"
                                            onChange={(e) => handleTextChange(e, e.target.type, "")}
                                            value={requestObj.clientId}
                                        />
                                    </div>
                                    <div className="form-group-item">
                                        <label>Client Secret *</label>
                                        <input
                                            type="text"
                                            className="form-control input-default w-100"
                                            id="clientSecret"
                                            placeholder="Client Secret"
                                            onChange={(e) => handleTextChange(e, e.target.type, "")}
                                            value={requestObj.clientSecret}
                                        />
                                    </div>
                                    <div className="form-group-item">
                                        <label>Post Logout Redirect Uri</label>
                                        <input
                                            type="text"
                                            className="form-control input-default w-100"
                                            id="postLogoutRedirectUris"
                                            placeholder="Post Logout Redirect Uri"
                                            onChange={(e) => handleTextChange(e, e.target.type, "")}
                                            value={requestObj.postLogoutRedirectUris}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row mb-2">
                                    {Children.toArray(Array.isArray(requestObj?.redirectUris) && requestObj.redirectUris.map((value, index) => (
                                        <div className="d-flex align-items-end form-group row mb-3">
                                            <div className="col-lg-11">
                                                <label>
                                                    Redirect Uri {index + 1}
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default"
                                                    placeholder={`Redirect Uri ${index + 1}`}
                                                    onChange={(e) => {
                                                        setRequestObj((prev) => ({
                                                            ...prev,
                                                            redirectUris: requestObj.redirectUris.map((state, stateIndex) =>
                                                                stateIndex === index ? e.target.value : state),
                                                        }));
                                                    }}
                                                    value={value}
                                                />
                                            </div>
                                            <div className="col-lg-1">
                                                <CloseButton
                                                    onClick={(e) => setRequestObj((prev) => ({
                                                        ...prev,
                                                        redirectUris: requestObj.redirectUris.filter((state, stateIndex) => stateIndex !== index),
                                                    }))}
                                                />
                                            </div>
                                        </div>
                                    ))
                                    )}
                                    <div className="my-3">
                                        <Button
                                            variant="primary"
                                            onClick={() => setRequestObj((prev) => ({
                                                ...prev,
                                                redirectUris: requestObj?.redirectUris ? [...requestObj.redirectUris, ""] : [""],
                                            }))}
                                        >
                                            Add Redirect Uri
                                        </Button>
                                    </div>
                                </div>
                                </div>
                                <div className="shadow p-3 mb-3 bg-body rounded database-div mt-1">
                                    <p className="mb-0">Primary Db Details</p>
                                    <hr className="my-1" />
                                    <div className="form-group row mb-3">
                                        <div className="form-group-item">
                                            <label>Host *</label>
                                            <input
                                                type="text"
                                                className="form-control input-default w-100"
                                                id="host"
                                                placeholder="Host"
                                                onChange={(e) => handleTextChange(e, e.target.type, "primaryDbDetail")}
                                                value={requestObj?.primaryDbDetail?.host}
                                            />
                                        </div>
                                        <div className="form-group-item">
                                            <label>Port *</label>
                                            <input
                                                type="text"
                                                className="form-control input-default w-100"
                                                id="port"
                                                placeholder="Port"
                                                onChange={(e) => handleTextChange(e, e.target.type, "primaryDbDetail")}
                                                value={requestObj?.primaryDbDetail?.port}
                                            />
                                        </div>
                                        <div className="form-group-item">
                                            <label>Database Name *</label>
                                            <input
                                                type="text"
                                                className="form-control input-default w-100"
                                                id="dbName"
                                                placeholder="Database Name"
                                                onChange={(e) => handleTextChange(e, e.target.type, "primaryDbDetail")}
                                                value={requestObj?.primaryDbDetail?.dbName}
                                            />
                                        </div>
                                        <div className="form-group-item">
                                            <label>Auth Db Name *</label>
                                            <input
                                                type="text"
                                                className="form-control input-default w-100"
                                                id="authDbName"
                                                placeholder="Auth Db Name"
                                                onChange={(e) => handleTextChange(e, e.target.type, "primaryDbDetail")}
                                                value={requestObj?.primaryDbDetail?.authDbName}
                                            />
                                        </div>
                                        <div className="form-group-item">
                                            <label>Auth User Name *</label>
                                            <input
                                                type="text"
                                                className="form-control input-default w-100"
                                                id="authUsername"
                                                placeholder="Auth User Name"
                                                onChange={(e) => handleTextChange(e, e.target.type, "primaryDbDetail")}
                                                value={requestObj?.primaryDbDetail?.authUsername}
                                            />
                                        </div>
                                        <div className="form-group-item">
                                            <label>Auth Password *</label>
                                            <input
                                                type="text"
                                                className="form-control input-default w-100"
                                                id="authPassword"
                                                placeholder="Password"
                                                onChange={(e) => handleTextChange(e, e.target.type, "primaryDbDetail")}
                                                value={requestObj?.primaryDbDetail?.authPassword}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="me-5">
                                        <input
                                            type="checkbox"
                                            name="secondaryDb"
                                            id="secondaryDb"
                                            checked={requestObj.secondaryDb}
                                            onChange={(e) => handleTextChange(e, e.target.type, "secondaryDbDetail")}
                                        />
                                        <label className="ms-2">Secondary Db</label>
                                    </div>
                                </div>
                                {requestObj.secondaryDb && (
                                    <div className="shadow p-3 mb-3 bg-body rounded database-div mt-1">
                                        <p className="mb-0">Secondary Db Details</p>
                                        <hr className="my-1" />
                                        <div className="form-group row mb-3">
                                            <div className="col-lg-4">
                                                <label>Host *</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default w-100"
                                                    id="host"
                                                    placeholder="Host"
                                                    onChange={(e) => handleTextChange(e, e.target.type, "secondaryDbDetail")}
                                                    value={requestObj?.secondaryDbDetail?.host}
                                                />
                                            </div>
                                            <div className="col-lg-4">
                                                <label>Port *</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default w-100"
                                                    id="port"
                                                    placeholder="Port"
                                                    onChange={(e) => handleTextChange(e, e.target.type, "secondaryDbDetail")}
                                                    value={requestObj?.secondaryDbDetail.port}
                                                />
                                            </div>
                                            <div className="col-lg-4">
                                                <label>Database Name *</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default w-100"
                                                    id="dbName"
                                                    placeholder="Database Name"
                                                    onChange={(e) => handleTextChange(e, e.target.type, "secondaryDbDetail")}
                                                    value={requestObj?.secondaryDbDetail?.dbName}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row mb-3">
                                            <div className="col-lg-4">
                                                <label>Auth Db Name *</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default w-100"
                                                    id="authDbName"
                                                    placeholder="Auth Db Name"
                                                    onChange={(e) => handleTextChange(e, e.target.type, "secondaryDbDetail")}
                                                    value={requestObj?.secondaryDbDetail?.authDbName}
                                                />
                                            </div>
                                            <div className="col-lg-4">
                                                <label>Auth User Name *</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default w-100"
                                                    id="authUsername"
                                                    placeholder="Auth User Name"
                                                    onChange={(e) => handleTextChange(e, e.target.type, "secondaryDbDetail")}
                                                    value={requestObj?.secondaryDbDetail?.authUsername}
                                                />
                                            </div>
                                            <div className="col-lg-4">
                                                <label>Auth Password *</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default w-100"
                                                    id="authPassword"
                                                    placeholder="Password"
                                                    onChange={(e) => handleTextChange(e, e.target.type, "secondaryDbDetail")}
                                                    value={requestObj?.secondaryDbDetail?.authPassword}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="form-group row">
                                    <div className="me-5">
                                        <input
                                            type="checkbox"
                                            name="backUpDb"
                                            id="backUpDb"
                                            checked={requestObj.backUpDb}
                                            onChange={(e) => handleTextChange(e, e.target.type, "backUpDbDetail")}
                                        />
                                        <label className="ms-2">Backup Db</label>
                                    </div>
                                </div>
                                {requestObj.backUpDb && (
                                    <div className="shadow p-3 mb-3 bg-body rounded database-div mt-1">
                                        <p className="mb-0">Backup Db Details</p>
                                        <hr className="my-1" />
                                        <div className="form-group row mb-3">
                                            <div className="col-lg-4">
                                                <label>Host *</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default w-100"
                                                    id="host"
                                                    placeholder="Host"
                                                    onChange={(e) => handleTextChange(e, e.target.type, "backUpDbDetail")}
                                                    value={requestObj?.backUpDbDetail?.host}
                                                />
                                            </div>
                                            <div className="col-lg-4">
                                                <label>Port *</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default w-100"
                                                    id="port"
                                                    placeholder="Port"
                                                    onChange={(e) => handleTextChange(e, e.target.type, "backUpDbDetail")}
                                                    value={requestObj?.backUpDbDetail?.port}
                                                />
                                            </div>
                                            <div className="col-lg-4">
                                                <label>Database Name *</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default w-100"
                                                    id="dbName"
                                                    placeholder="Database Name"
                                                    onChange={(e) => handleTextChange(e, e.target.type, "backUpDbDetail")}
                                                    value={requestObj?.backUpDbDetail?.dbName}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row mb-3">
                                            <div className="col-lg-4">
                                                <label>Auth Db Name *</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default w-100"
                                                    id="authDbName"
                                                    placeholder="Auth Db Name"
                                                    onChange={(e) => handleTextChange(e, e.target.type, "backUpDbDetail")}
                                                    value={requestObj?.backUpDbDetail?.authDbName}
                                                />
                                            </div>
                                            <div className="col-lg-4">
                                                <label>Auth User Name *</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default w-100"
                                                    id="authUsername"
                                                    placeholder="Auth User Name"
                                                    onChange={(e) => handleTextChange(e, e.target.type, "backUpDbDetail")}
                                                    value={requestObj?.backUpDbDetail?.authUsername}
                                                />
                                            </div>
                                            <div className="col-lg-4">
                                                <label>Auth Password *</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-default w-100"
                                                    id="authPassword"
                                                    placeholder="Password"
                                                    onChange={(e) => handleTextChange(e, e.target.type, "backUpDbDetail")}
                                                    value={requestObj?.backUpDbDetail?.authPassword}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="shadow p-3 mb-3 bg-body rounded database-div mt-1">
                                    <div className="form-group row mb-3">
                                        <div className="form-group-item">
                                            <label>Auth Code Time To Live *</label>
                                            <input
                                                type="number"
                                                className="form-control input-default w-100"
                                                id="authorizationCodeTimeToLive"
                                                name="authorizationCodeTimeToLive"
                                                placeholder="Authorization Code Time To Live"
                                                onChange={(e) => handleNumbers(e)}
                                                value={requestObj?.authorizationCodeTimeToLive}
                                            />
                                        </div>
                                        <div className="form-group-item">
                                            <label>Access Token Time To Live *</label>
                                            <input
                                                type="number"
                                                className="form-control input-default w-100"
                                                id="accessTokenTimeToLive"
                                                name="accessTokenTimeToLive"
                                                placeholder="Access Token Time To Live"
                                                onChange={(e) => handleNumbers(e)}
                                                value={requestObj?.accessTokenTimeToLive}
                                            />
                                        </div>
                                        <div className="form-group-item">
                                            <label>Device Code Time To Live *</label>
                                            <input
                                                type="number"
                                                className="form-control input-default w-100"
                                                id="deviceCodeTimeToLive"
                                                name="deviceCodeTimeToLive"
                                                placeholder="Device Code Time To Live"
                                                onChange={(e) => handleNumbers(e)}
                                                value={requestObj?.deviceCodeTimeToLive}
                                            />
                                        </div>
                                        <div className="form-group-item">
                                            <label>Refresh Token Time To Live *</label>
                                            <input
                                                type="number"
                                                className="form-control input-default w-100"
                                                id="refreshTokenTimeToLive"
                                                name="refreshTokenTimeToLive"
                                                placeholder="Refresh Token Time To Live"
                                                onChange={(e) => handleNumbers(e)}
                                                value={requestObj?.refreshTokenTimeToLive}
                                            />
                                        </div>
                                        <div className="form-group-item">
                                            <MultiSelect
                                                options={ACCESS_TOKEN_OPTIONS}
                                                selectedValues={requestObj.accessTokenFormat}
                                                onChange={handleMultiSelectChange}
                                                fieldName="accessTokenFormat"
                                                isMulti={false}
                                            />
                                        </div>
                                        <div className="form-group-item">
                                            <MultiSelect
                                                options={TOKEN_SIGNATURE_ALGORITHM_OPTIONS}
                                                selectedValues={requestObj.idTokenSignatureAlgorithm}
                                                onChange={handleMultiSelectChange}
                                                fieldName="idTokenSignatureAlgorithm"
                                                isMulti={false}
                                            />
                                        </div>
                                        <div className="form-group-item formCheckbox ">
                                            <input
                                                type="checkbox"
                                                // className="form-control input-default"
                                                id="reuseRefreshTokens"
                                                // onChange={(e) => handleTextChange(e, e.target.type, "backUpDbDetail")}
                                                // value={requestObj?.reuseRefreshTokens}
                                                checked={requestObj?.reuseRefreshTokens}
                                                onChange={(e) => handleChecked(e, "reuseRefreshTokens")}
                                            />
                                            <label htmlFor="reuseRefreshTokens">Reuse Refresh Tokens</label>
                                        </div>
                                        <div className="form-group-item formCheckbox">
                                            <input
                                                type="checkbox"
                                                // className="form-control input-default"
                                                id="requireProofKey"
                                                // onChange={(e) => handleTextChange(e, e.target.type, "backUpDbDetail")}
                                                // value={requestObj?.reuseRefreshTokens}
                                                checked={requestObj?.requireProofKey}
                                                onChange={(e) => handleChecked(e, "requireProofKey")}
                                            />
                                            <label htmlFor="requireProofKey">Require Proof Key</label>
                                        </div>
                                        <div className="form-group-item formCheckbox">
                                            <input
                                                type="checkbox"
                                                // className="form-control input-default"
                                                id="requireAuthorizationConsent"
                                                // onChange={(e) => handleTextChange(e, e.target.type, "backUpDbDetail")}
                                                // value={requestObj?.reuseRefreshTokens}
                                                checked={requestObj?.requireAuthorizationConsent}
                                                onChange={(e) => handleChecked(e, "requireAuthorizationConsent")}
                                            />
                                            <label htmlFor="requireAuthorizationConsent">Require Authorization Consent</label>
                                        </div>
                                        <div className="form-group-item">
                                            <label>Scopes *</label>
                                            <span>
                                                {requestObj?.scopes?.map((value, index) => (
                                                    <div key={index}>
                                                        {value}
                                                        <span>
                                                            <CloseButton
                                                                onClick={() =>
                                                                    setRequestObj((prev) => ({
                                                                        ...prev,
                                                                        scopes: prev.scopes.filter((_, stateIndex) => stateIndex !== index),
                                                                    }))
                                                                }
                                                            />
                                                        </span>
                                                    </div>
                                                ))}
                                            </span>
                                            <input
                                                className="form-control input-default w-100"
                                                id="scopesInput"
                                                onKeyDown={(e) => handleMultiTabs(e)}
                                                isMulti
                                            />
                                        </div>

                                        <div className="form-group-item">
                                            <MultiSelect
                                                options={CLIENT_AUTHENTICATION_METHODS}
                                                selectedValues={requestObj.clientAuthenticationMethods || []}
                                                onChange={handleMultiSelectChange}
                                                fieldName="clientAuthenticationMethods"
                                                isMulti={true}
                                            />
                                        </div>
                                        <div className="form-group-item">
                                            <MultiSelect
                                                options={AUTHORIZATION_GRANT_TYPES_OPTIONS}
                                                selectedValues={requestObj.authorizationGrantTypes || []}
                                                onChange={handleMultiSelectChange}
                                                fieldName="authorizationGrantTypes"
                                                isMulti={true}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row justify-content-end">
                            <div className="col-lg-3 text-end">
                                <Button
                                    variant="success"
                                    onClick={clientId !=='add-client'?updateClient:createClient}
                                    // disabled={loading} // Disable button while updating
                                >
                                    {loading ? "Updating..." : (clientId !=='add-client'?"Update General Info":"Create Client")}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Tab>
                {clientId !=='add-client' && <Tab eventKey="users" title="Users">
                    {<DocumentList
                        documentMeta={UserClientAccess}
                        isModel={true}
                    />} 
                </Tab>}
                <Tab eventKey="createWithPrompt" title="Create with Prompt">
                    <div className="row justify-content-end my-3">
                        <div className="col-12">
                            <div className="card mb-0">
                                <div className="card-body p-3">
                                    <PromptEditor />
                                </div>
                            </div>
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="Config" title="Config">
                    <div className="row justify-content-end my-3">
                        <div className="col-12">
                            <ClientConfig requestObj={requestObj} />
                        </div>
                    </div>
                </Tab>
            </Tabs>

        </>
    );
};

export default ClientAddUpdate;
